import moment from '@/plugins/vue-moment.js';

class ActivityHelper {
    getSectionDueDates(item, rootGetters, template) {
        const settings = item.type.includes('temp') ? 'section_settings_template' : 'section_settings';
        const setting_namespace = settings.includes('temp') ? 'SectionTemplates' : 'Sections';
        const timezone = rootGetters['InstitutionSettings/get']('timezone');

        if (item.parent_id) {
            const parent = rootGetters[`${setting_namespace}/getByKey`]({
                keyName: 'id',
                key: Number(item.parent_id),
            });

            if (!parent.parent_id) {
                if (!template) {
                    return {
                        type: parent.sectionType,
                        week: {
                            start: this.formatDate(parent[settings].week_start, timezone),
                            end: this.formatDate(parent[settings].week_end, timezone),
                        },
                    };
                }

                return {
                    type: parent.sectionType,
                    week: parent[settings].week_number,
                };
            }

            return this.getSectionDueDates(parent, rootGetters, template);
        }

        return template
            ? { type: item.sectionType, week: item[settings].week_number }
            : {
                  type: item.sectionType,
                  week: {
                      start: this.formatDate(item[settings].week_start, timezone),
                      end: this.formatDate(item[settings].week_end, timezone),
                  },
              };
    }

    formatDate(date, timezone) {
        if (!timezone) {
            throw new Error('Timezone must be present in order to format the date.');
        }

        return moment.utc(date).tz(timezone).toDate();
    }
}

export default ActivityHelper;
